import { ScrollTrigger } from "gsap/ScrollTrigger";

const timelineItems = document.querySelectorAll('.js-timeline-item');

timelineItems.forEach(item => {
  ScrollTrigger.create({
    trigger: item,
    start: "top 300px",
    end: "bottom center",
    onEnter: () => {
      timelineItems.forEach(el => el.classList.remove('active'));
      item.classList.add('active');
    },
    onEnterBack: () => {
      timelineItems.forEach(el => el.classList.remove('active'));
      item.classList.add('active');
    },
  });
});
